import { render, staticRenderFns } from "./m_cis_business.vue?vue&type=template&id=732bf427&scoped=true"
import script from "./m_cis_business.vue?vue&type=script&lang=js"
export * from "./m_cis_business.vue?vue&type=script&lang=js"
import style0 from "./m_cis_business.vue?vue&type=style&index=0&id=732bf427&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732bf427",
  null
  
)

export default component.exports